import React from 'react';
import {PinForm} from "../shared/pin-form";
import {DocItem} from "./doc-item";
import {SectionTitle} from "./section-title";
import {NoRecords} from "../shared/no-records";

import styles from './styles.module.scss';

export const MobileView = ({docs}) => {

  if(docs.length === 0) return <NoRecords/>;

  return (
    <div className={styles.mobileContainer}>
      <SectionTitle title="DATOS GENERALES"/>
      <div className="px-4">
        <PinForm docs={docs}/>
      </div>

      <SectionTitle title={`DOCUMENTOS (${docs?.length})`}/>
      <p className="px-4 text-sm font-semibold">Poder Simple</p>
      <div className="grid grid-cols-1 gap-3 px-4 pb-4">
        {
          docs?.map( doc =>  <DocItem key={doc.id} doc={doc}/>)
        }
      </div>
    </div>
  );
};
